import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IAuditTrailFields {
		id?: any;
		deleteAction?: any;
		updateAction?: any;
		createAction?: any;
		columnDataType?: any;
		columnName?: any;
		newValue?: any;
		oldValue?: any;
		primaryKeyName?: any;
		primaryKeyValue?: any;
		tableName?: any;
		userId?: any;
		datestamp?: any;
		auditType?: any;
		auditTypeIdentifier?: any;
		auditTrailCommentId?: any;
}

export class AuditTrailFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public deleteAction: IEntityModelField = { name: "deleteAction", displayName: "Delete Action", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public updateAction: IEntityModelField = { name: "updateAction", displayName: "Update Action", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public createAction: IEntityModelField = { name: "createAction", displayName: "Create Action", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public columnDataType: IEntityModelField = { name: "columnDataType", displayName: "Column Data Type", fieldType: FieldType.String, pattern: "NameGeneric" };
	public columnName: IEntityModelField = { name: "columnName", displayName: "Column Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public newValue: IEntityModelField = { name: "newValue", displayName: "New Value", fieldType: FieldType.String, pattern: "NameGeneric" };
	public oldValue: IEntityModelField = { name: "oldValue", displayName: "Old Value", fieldType: FieldType.String, pattern: "NameGeneric" };
	public primaryKeyName: IEntityModelField = { name: "primaryKeyName", displayName: "Primary Key Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public primaryKeyValue: IEntityModelField = { name: "primaryKeyValue", displayName: "Primary Key Value", fieldType: FieldType.String, pattern: "NameGeneric" };
	public tableName: IEntityModelField = { name: "tableName", displayName: "Table Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public userId: IEntityModelField = { name: "userId", displayName: "User Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public auditType: IEntityModelField = { name: "auditType", displayName: "Audit Type", fieldType: FieldType.String, pattern: "NameGeneric" };
	public auditTypeIdentifier: IEntityModelField = { name: "auditTypeIdentifier", displayName: "Audit Type Identifier", fieldType: FieldType.String, pattern: "NameGeneric" };
	public auditTrailCommentId: IEntityModelField = { name: "auditTrailCommentId", displayName: "Audit Trail Comment Id", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.deleteAction);
		this.push(this.updateAction);
		this.push(this.createAction);
		this.push(this.columnDataType);
		this.push(this.columnName);
		this.push(this.newValue);
		this.push(this.oldValue);
		this.push(this.primaryKeyName);
		this.push(this.primaryKeyValue);
		this.push(this.tableName);
		this.push(this.userId);
		this.push(this.datestamp);
		this.push(this.auditType);
		this.push(this.auditTypeIdentifier);
		this.push(this.auditTrailCommentId);
	}
}

export class AuditTrailDTO implements IEntityModel {
	protected auditTrailName: string = "AuditTrailModel";
	protected auditTrailKeyField: string = "id";
	protected auditTrailDisplayName: string = "Audit Trail|Audit Trail";
	protected auditTrailFields = new AuditTrailFields();
	public get name(): string { return this.auditTrailName };
	public get keyField(): string { return this.auditTrailKeyField };
	public get displayName(): string { return this.auditTrailDisplayName };
	public get fields(): AuditTrailFields { return this.auditTrailFields };

	constructor() {};
}
